<template>
    <div class="widget-card">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">

</script>

<style lang="scss" scoped>
.widget-card {
    --tl-wc-card-width: 420px;
    position: relative;
    background-color: var(--tl-widget-background-color);
    width: var(--tl-wc-card-width);
    height: 100%;
    max-height: 580px;
    border-radius: 22px;
    overflow: hidden;
    display: flex;
    flex-flow: column;
    position: relative;
    transition: 0s;
    box-shadow: 0 10px 50px -20px rgba(0,0,0,0.3);
    @media (max-width: 460px) {
        max-height: none;
    }
}
</style>
